import { DragDropModule } from "@angular/cdk/drag-drop";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatStepperModule } from "@angular/material/stepper";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { config } from "@config/config";
import { AppConfigService, CoreConfig, SocketRooms } from "@master/core/dist/core";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ScreenKeyboardComponent } from "./components/screen-keyboard/screen-keyboard.component";
import { SendmailComponent } from "./dialogs/sendmail/sendmail.component";
import { TransportFormComponent } from "./pages/transport-form/transport-form.component";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { TimePipe } from "./pipes/time.pipe";
import { NgxTranslateModule } from "./ngx.translate.module";


/* Runtime Config */

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    TransportFormComponent,
    SendmailComponent,
    ScreenKeyboardComponent,
    TimePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatButtonModule,
    MatTooltipModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatIconModule,
    MatDividerModule,
    MatStepperModule,
    HttpClientModule,
    MatDialogModule,
    MatSnackBarModule,
    DragDropModule,
    MatTooltipModule,
    NgxExtendedPdfViewerModule,
    MatToolbarModule,
    NgxTranslateModule
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: CoreConfig.API_BASE_URL, useValue: config.apiBaseUrl },
    { provide: CoreConfig.LOCAL_CONFIG, useValue: config.localConfig },
    { provide: CoreConfig.SOCKET_IO_PATH, useValue: config.socketIo },
    { provide: CoreConfig.SOCKET_ROOM, useValue: SocketRooms.QR_GENERATOR_ROOM },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  ],
  entryComponents: [SendmailComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
